import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "children", "max_width", "align", "justify", "direction", "gap"];
import clsx from "clsx";
import React from "react";
import { createMemoClass } from "../create-memo-class";
import { useMaxWidthClasses } from "../shared-classes";
import { jsx as _jsx } from "react/jsx-runtime";
export var Flex = _ref => {
  var {
    className,
    children,
    max_width,
    align = "center",
    justify = "center",
    direction,
    gap
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = useFlexClass({
    max_width,
    align,
    justify,
    direction,
    gap
  });
  return /*#__PURE__*/_jsx("div", _extends({
    className: clsx(classes, className)
  }, rest, {
    children: children
  }));
};
var useFlexClass = createMemoClass(props => {
  var max_width = useMaxWidthClasses(props.max_width);
  var aligns = {
    center: "items-center",
    start: "items-start",
    end: "items-end"
  };
  var justifys = {
    center: "justify-center",
    start: "justify-start",
    end: "justify-end",
    between: "justify-between",
    evenly: "justify-evenly",
    around: "justify-around"
  };
  var directions = {
    row: "flex-row",
    column: "flex-col"
  };
  var gaps = {
    "2": "gap-2",
    "4": "gap-4",
    "8": "gap-8",
    "16": "gap-16"
  };
  var classes = clsx("flex flex-wrap", max_width, aligns[props.align], justifys[props.justify], directions[props.direction], gaps[props.gap]);
  return classes;
});
//# sourceMappingURL=flex.js.map